/** Batas teks mengikuti Instagram; harus sama dengan api/services/posts.ts. */
export const TEXT_LIMITS = {
  TITLE: 100,
  DESCRIPTION: 500,
  ALT_TEXT: 500,
} as const

export const PIN_STATUS_LABEL: Record<string, { text: string; className: string }> = {
  draft: { text: 'Draft', className: 'bg-muted text-muted-foreground' },
  queued: { text: 'Queued', className: 'bg-sky-500/15 text-sky-400' },
  scheduled: { text: 'Scheduled', className: 'bg-indigo-500/15 text-indigo-400' },
  dispatched: { text: 'Dispatched', className: 'bg-violet-500/15 text-violet-400' },
  posting: { text: 'Posting', className: 'bg-violet-500/15 text-violet-400' },
  posted: { text: 'Published', className: 'bg-emerald-500/15 text-emerald-400' },
  failed: { text: 'Failed', className: 'bg-destructive/15 text-destructive' },
  cancelled: { text: 'Cancelled', className: 'bg-muted text-muted-foreground' },
}
